import {Component, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {AmenitiesService} from '../../../services/amenities.service';
import {AuthenticationService} from '../../../services/authentication.service';


@Component({
    selector: 'amenities-view',
    templateUrl: './amenities-view.component.html',
    styleUrls: ['./amenities-view.component.scss']
})
export class AmenitiesViewComponent implements OnInit {

    activeTab = 'info';
    showModal = false;

    constructor(
        public api: ApiClientService,
        public amenitiesService: AmenitiesService,
        public authService: AuthenticationService
    ) {

    }

    ngOnInit() {
        this.amenitiesService.amenityInAmenityModal.notes.sort((a: any, b: any) => {
            if (new Date(a.createdAt) < new Date(b.createdAt)) {
                return 1;
            } else if (new Date(a.createdAt) > new Date(b.createdAt)) {
                return -1;
            } else {
                return 0;
            }
        });
        setTimeout( () => this.showModal = true, 300);
    }

    changeTab(tab) {
        this.activeTab = tab;
    }


    hideModal() {
        this.amenitiesService.isAmenityViewShow = false;
        this.amenitiesService.amenityInAmenityModal = null;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-view/amenities-view.component.ts